/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2018 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	Button.js
 *
 * Description:	The logic for handling Button elements.
 *
 * History:		07-JUN-13	S Brown		Initial implementation.
 *				02-JUL-13	S Brown		Framework complete.
 *				14-FEB-14	S Brown		Global Change of icon names to contain their resolution within the filename.
 *				12-JUL-14	J Collins	Added Digital Asset Management Module.
 *				14-OCT-16	P Dickson	Modern interface implementation.
 *
 *
 * */

/*
 *  - - - G L O B A L   V A R I A B L E S - - -
 */

	var g_aGraphicalButtons = new Array();
	var g_szGraphicalButtonOldTxtColour = "";
	var g_iGraphicalButtonExecutionTimeout = 0;
	var g_szGraphicalButtonSourceRef = "";
	var g_oGraphicalButtonSourceRef = null;
	var g_szSkinFolder = "";


	var g_szSourcePath = "";

/*
 *  - - - C O N S T A N T S - - -
 */

	var c_szGB_CSS_Normal = "button";
	var c_szGB_CSS_Disabled = "button_D";
	var c_szGB_CSS_Highlight = "button_HL";
	var c_szGB_CSS_Pressed = "button_P";
	var c_szImgLoadIcon = "img/icon/cls/Loading16.gif";


/*
 *  - - - O B J E C T   P R O T O T Y P E S - - -
 */

	// Graphical Button object prototype.
	function graphicalButton(buttonId, command, disabled, imageN, imageHL, imageD, persistentButton){
		this.buttonId = buttonId;
		this.command = command;
		this.disabled = disabled;
		this.imageN = imageN;
		this.imageHL = imageHL;
		this.imageD = imageD;
		this.defaultButton = false;		// Default to false - this forces us to switch it on manually, therefore reducing the risk of bugs.
		this.persistentButton = persistentButton;
		this.isLoading = false;
	}


/*
 *  - - - P U B L I C   M E T H O D S - - -
 */

	// Function to clear all graphical buttons from the collection.
	function gb_clearAll(){
		var oTmp = g_aGraphicalButtons;
		g_aGraphicalButtons = new Array();
		var iLen = oTmp.length;
		for (var i=0; i<iLen; i++){
			if (oTmp[i].persistentButton)
				g_aGraphicalButtons[g_aGraphicalButtons.length] = oTmp[i];
		}
		g_szGraphicalButtonOldTxtColour = "";
		g_iGraphicalButtonExecutionTimeout = 0;

		if (g_oGraphicalButtonSourceRef == null)
			g_oGraphicalButtonSourceRef = this;
	}

	// Function to disable a graphical button.
	function gb_disable(buttonId){

		if ($("#" + buttonId).exists()){
			$("#" + buttonId).attr("class", c_szGB_CSS_Disabled);
			var i = gb_getItem(buttonId);
			if (i)
				i.disabled = true;
			if ($("#" + buttonId + "_img").exists() && i.isLoading == false)
				$("#" + buttonId + "_img").attr("src", i.imageD);
		}
	}

	// Function to enable a graphical button.
	function gb_enable(buttonId){

		if ($("#" + buttonId).exists()) {
			$("#" + buttonId).attr("class", c_szGB_CSS_Normal);
			var i = gb_getItem(buttonId);
			if (i) {
				i.disabled = false;
				i.isLoading = false;
			}
			if ($("#" + buttonId + "_img").exists())
				$("#" + buttonId + "_img").attr("src", i.imageN);
		}
	}

	// Function to execute a graphical buttons command.
	function gb_exec(buttonId){
		if (g_iGraphicalButtonExecutionTimeout == 0){
			var i = gb_getItem(buttonId);
			if (!i.disabled){
				new Function(i.command)();
			}
			g_iGraphicalButtonExecutionTimeout = 1;
			window.setTimeout("g_iGraphicalButtonExecutionTimeout=0;", 500);
			gb_out(buttonId);
		}
	}

	// Gets the ID of the current default graphical button.
	function gb_getDefaultButton() {
		var szID = "";
		var iLen = g_aGraphicalButtons.length;
		for (var i=0; i<iLen; i++){
			if (g_aGraphicalButtons[i].defaultButton) {
				szID = g_aGraphicalButtons[i].buttonId;
				break;
			}
		}
		return szID;
	}

	// Gets a reference to the collection item with the specified button id.
	function gb_getItem(buttonId){
		var iLen = g_aGraphicalButtons.length;
		for (var i=0; i<iLen; i++){
			if (g_aGraphicalButtons[i].buttonId == buttonId)
				return g_aGraphicalButtons[i];
		}
		return null;
	}

	// Renders the graphical buttons mouse-over state.
	function gb_over(buttonId){

		if ($("#" + buttonId).exists()) {
			var i = gb_getItem(buttonId);
			if (!i.disabled) {
				$("#" + buttonId).attr("class", c_szGB_CSS_Highlight);
				if ($("#" + buttonId + "_img").exists() && i.imageHL.length > 0)
					$("#" + buttonId + "_img").attr("src", i.imageHL);
			}
		}
	}

	// Renders the graphical buttons mouse-out state.
	function gb_out(buttonId){

		if ($("#" + buttonId).exists()){
			var i = gb_getItem(buttonId);
			if (!i.disabled){
				$("#" + buttonId).attr("class", c_szGB_CSS_Normal);
				if ($("#" + buttonId + "_img").exists())
					$("#" + buttonId + "_img").attr("src", i.imageN);
			}
		}
	}

	// Renders the graphical buttons pressed state..
	function gb_press(buttonId){

		if ($("#" + buttonId).exists()){
			var i = gb_getItem(buttonId);
			if (!i.disabled){
				$("#" + buttonId).attr("class", c_szGB_CSS_Pressed);
			}
		}
	}

	// Processes the first instance of a default button.
	function gb_processDefaultButton(){
		var iLen = g_aGraphicalButtons.length;
		for (var i=0; i<iLen; i++){
			if (g_aGraphicalButtons[i].defaultButton){
				gb_exec(g_aGraphicalButtons[i].buttonId);
				break;
			}
		}
	}

	// Removes any duplicate items from the collection.
	function gb_removeDuplicate(buttonId){
		if (g_aGraphicalButtons.length > 0){
			var aTmpButtons = g_aGraphicalButtons;
			g_aGraphicalButtons = new Array();
			var iLen = aTmpButtons.length;
			for (var i=0; i<iLen; i++){
				if (aTmpButtons[i].buttonId != buttonId)
					g_aGraphicalButtons[g_aGraphicalButtons.length] = aTmpButtons[i];
			}
		}
	}

	// Renders the graphical button.
	function gb_render(buttonId, buttonWidth, buttonHeight, buttonPaddingHorizontal, buttonPaddingVertical, buttonText, buttonImage, buttonHLImage, buttonDImage, buttonImageText, buttonCommand, buttonDisabled, layerName, returnString, persistentButton, skinFolder){

		// Add the new dialog into the collection.
		gb_removeDuplicate(buttonId);
		var oNewButton = new graphicalButton(buttonId, buttonCommand, buttonDisabled, g_szSourcePath + buttonImage, g_szSourcePath + buttonHLImage, g_szSourcePath + buttonDImage, persistentButton);
		g_aGraphicalButtons[g_aGraphicalButtons.length] = oNewButton;

		// Render the HTML for the button.
		var szHTML = "<table border='0' cellpadding='0' cellspacing='1' ";
		if (!isNothing(buttonWidth)){ szHTML += "width='" + buttonWidth + "' "; }
		if (!isNothing(buttonHeight)){ szHTML += "height='" + buttonHeight + "' "; }
		szHTML += "><tr><td>";

		// Button
		szHTML += "<div id='divBtn_" + buttonId + "' >";
		szHTML += "<table border='0' cellpadding='2' cellspacing='0' width='100%' height='100%' align='center' valign='middle'>";
		szHTML += "<tr><td nowrap id='" + buttonId + "' align='center' valign='middle' class='" + c_szGB_CSS_Normal + "'";
		if (!isNothing(buttonWidth)){ szHTML += "width='" + buttonWidth + "' "; }
		if (!isNothing(buttonHeight)){ szHTML += "height='" + buttonHeight + "' "; }
		szHTML += "onMouseOver=\"" + g_szGraphicalButtonSourceRef + "gb_over('" + buttonId + "');\" onMouseOut=\"" + g_szGraphicalButtonSourceRef + "gb_out('" + buttonId + "');\" onMouseDown=\"" + g_szGraphicalButtonSourceRef + "gb_press('" + buttonId + "');\" ";
		szHTML += "style='";
		if (!isNothing(buttonPaddingHorizontal)){ szHTML += "padding-left: " + buttonPaddingHorizontal + "; padding-right: " + buttonPaddingHorizontal + ";"; }
		if (!isNothing(buttonPaddingVertical)){ szHTML += "padding-top: " + buttonPaddingVertical + "; padding-bottom: " + buttonPaddingVertical + ";"; }
		szHTML += "' onClick=\"" + g_szGraphicalButtonSourceRef + "gb_exec('" + buttonId + "');\">";
		if (!isNothing(buttonImage) && (buttonId == "login" || g_oUserProfile.skinFolder == "cls")) {
			if (isNothing(buttonText)){ szHTML += "&nbsp;"; }
			szHTML += "<img id='" + buttonId + "_img' src='" + g_szSourcePath + buttonImage + "' border='0' align='absmiddle' alt=\"" + buttonImageText + "\" title=\"" + buttonImageText + "\">&nbsp;";
		}
		if (!isNothing(buttonText)){ szHTML += buttonText; }
		if (g_iCurrentPlatform == 2)	// Apple Mac.
			szHTML += "<a href=\"javascript:" + g_szGraphicalButtonSourceRef + "gb_exec('" + buttonId + "');\" ";
		else
			szHTML += "<a href='#' onclick=\"" + g_szGraphicalButtonSourceRef + "gb_exec('" + buttonId + "');\" ";
		szHTML += "onFocus=\"" + g_szGraphicalButtonSourceRef + "gb_over('" + buttonId + "');\" onBlur=\"" + g_szGraphicalButtonSourceRef + "gb_out('" + buttonId + "');\"><img src='" + g_szSourcePath + "img/hdr/" + skinFolder + "/shim.gif' border='0'></a>";
		szHTML += "</td></tr></table>";
		szHTML += "</div></td></tr>";
		szHTML += "</table>";

		// If the layer name has been given, place the button
		//  into it; if returnString is TRUE, return the HTML
		//   to the caller; otherwise simply render it inline.
		if (!isNothing(layerName)){
			if ($("#" + layerName)) {
				$("#" + layerName).html(szHTML);
			}
		}
		else if (returnString){ return szHTML; }
		else { document.write(szHTML); }

		// Set the buttons initial state.
		if (buttonDisabled){ gb_disable(buttonId) }
		else { gb_enable(buttonId); }
		return "";
	}

	// Sets the command of the graphical button.
	function gb_setCommand(buttonId, command){
		var iLen = g_aGraphicalButtons.length;
		for (var i=0; i<iLen; i++){
			if (g_aGraphicalButtons[i].buttonId == buttonId)
				g_aGraphicalButtons[i].command = command;
		}
	}

	// Sets the default graphical button (setting all other
	//  buttons to false in the process).
	function gb_setDefaultButton(buttonId){
		var iLen = g_aGraphicalButtons.length;
		for (var i=0; i<iLen; i++){
			if (g_aGraphicalButtons[i].buttonId != buttonId)
				g_aGraphicalButtons[i].defaultButton = false;
			else
				g_aGraphicalButtons[i].defaultButton = true;
		}
	}

	// Switches a buttons image to the loading icon and disables the button.
	function gb_setLoading(buttonId) {
		if ($("#" + buttonId + "_img").exists()) {
			$("#" + buttonId + "_img").attr("src", c_szImgLoadIcon);
			var oBtn = gb_getItem(buttonId);
			oBtn.isLoading = true;
		}
	}